<script setup>
    import Header from '../../components/partials/HeaderPage.vue';
    import '@/assets/css/main.css'
    import '@/assets/scss/helpers.scss'
</script>

<template>
    <div class="CompaniesLayout">
        <Header/>
        <div class="main-content-container">        
            <div class="main-content">
                <div class="page-content">
                    <main class="w-full px-4">
                        <slot/>
                    </main>
                </div>
            </div>
        </div>
    </div>
</template>